import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Quotes } from "@phosphor-icons/react";
import { API } from "@/lib/site";

export const Spotlight = () => {
  const [data, setData] = useState(null);
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    fetch(`${API}/settings/spotlight`)
      .then((r) => r.json())
      .then((d) => setData(d))
      .catch(() => {});
  }, []);

  const items = data?.items || [];

  useEffect(() => {
    if (items.length < 2) return;
    const t = setInterval(() => setIdx((i) => (i + 1) % items.length), 6000);
    return () => clearInterval(t);
  }, [items.length]);

  if (!data || !data.enabled || items.length === 0) return null;
  const current = items[idx % items.length];

  return (
    <section className="relative py-24 lg:py-32 overflow-hidden" data-testid="spotlight-section">
      <div className="absolute inset-0 grain opacity-100" />
      <div className="max-w-5xl mx-auto px-6 lg:px-10 text-center relative z-10">
        <Quotes size={48} weight="fill" className="text-brand-gold/50 mx-auto mb-8" />
        <AnimatePresence mode="wait">
          <motion.blockquote
            key={idx}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
            className="font-serif text-3xl sm:text-4xl lg:text-5xl font-light text-brand-text leading-snug"
          >
            "{current.quote}"
            <span className="block overline mt-8">{current.attribution || "Client"}</span>
          </motion.blockquote>
        </AnimatePresence>
        {items.length > 1 && (
          <div className="flex justify-center gap-2 mt-10">
            {items.map((_, i) => (
              <button
                key={i}
                onClick={() => setIdx(i)}
                data-testid={`spotlight-dot-${i}`}
                className={`h-2 rounded-full transition-all duration-300 ${i === idx % items.length ? "w-8 bg-brand-gold" : "w-2 bg-brand-line"}`}
              />
            ))}
          </div>
        )}
      </div>
    </section>
  );
};
